<script>
  import { createEventDispatcher } from "svelte";

  let dispatch = createEventDispatcher();
</script>

<svelte:head>
  <title>404 | eAdmissions</title>
</svelte:head>
<section class="hero is-fullheight" style="background-color: #407f8a;">
  <div class="hero-body">
    <div class="container">
        <div style="text-align:center;">
            <a href="/">
              <img
                style="height:40px"
                src="/eamissions-logo.png"
                alt="eAdmissions Logo"  title="Go to home page" />
            </a>
        </div>
        <div class="columns is-centered">
          <div class="column is-7-tablet is-6-desktop is-5-widescreen">
              <div class="box">
                <div class="has-text-centered">
                <br>
                <h1 class="title is-4">404 Error</h1>
                <h1 class="subtitle is-5">Page Not Found!</h1>
                <p style="margin-bottom: 10px;">
                Sorry, the page you are trying to access does not exist. 
                <br>
                Please check the URL or
                <a href="/">Go to home page</a>
                </p>
                </div>
              </div>
          </div>
        </div>
</section>
